/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-22 14:56:11
 */
 
import { createRouter, createWebHashHistory, RouteRecordRaw,useRoute } from 'vue-router'
import Layout from '@/layout/Index.vue'
import { useStore } from '../store'
import { loginRequest } from '@/apis/getToken'
import { ElMessage } from "element-plus";
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { AppActionTypes } from '@/store/modules/app/action-types'
import { getLanguage } from "@/utils/cookies";

const store = useStore()

console.log(useStore().state.user.token,'获取一次')

const constantFiles = require.context('./constantModules', true, /\.ts$/)
console.log('constantFiles=>', constantFiles)
let constantModules: Array<RouteRecordRaw> = []
constantFiles.keys().forEach((key) => {
  if (key === './index.ts') return
  constantModules = constantModules.concat(constantFiles(key).default)
})
// let abc=['robot','disinfectTask','building','disinfect']
const asyncFiles = require.context('./permissionModules', true, /\.ts$/)
let permissionModules: Array<RouteRecordRaw> = []
asyncFiles.keys().forEach((key,index) => {
  // console.log(key,asyncFiles(key))
  // ||asyncFiles(key).default[0].meta.title!=abc
  if (key === './index.ts') return
  // if (asyncFiles(key).default[0].meta.title!=abc[index]) return
  // abc.map((ele,indexs)=>{
  //   if (ele === asyncFiles(key).default[0].meta.title) {
  //     permissionModules = permissionModules.concat(asyncFiles(key).default)
  //   }
  // })
  permissionModules = permissionModules.concat(asyncFiles(key).default)
})

export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/redirect',
    component: Layout,
    // meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect/Index.vue')
      }
    ]
  },
  ...constantModules
]
// console.log(useRoute)
export const asyncRoutes: Array<RouteRecordRaw> = [
  ...permissionModules
]
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes
})


router.beforeEach((to, from, next) => {
    // 错误的企业号进不去登录页
    if(to.query.companyId){
      loginRequest({ username:'admin', password:'12312', company_id:to.query.companyId }).then((res:any)=>{
        if(res.code != '40001'){
          next()
        }else {
          ElMessage.error(_t('login.enterpriseerror'))
        }
      })
    }else if(to.path == '/login'){
      if(getLanguage()){ // 判断是否是第一次进入登录页
        next()
      }else{
        // 第一次进入登录页获取浏览器语言
        let navigatorLanguage = navigator.language.toLowerCase()
        store.dispatch(AppActionTypes.ACTION_SET_LANGUAGE, navigatorLanguage) // 存储默认语言
        next()
      }
    }else {
      next()
    }
});

export function resetRouter() {
  const newRouter = router;
  (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
